/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @type {string} Auditions action types.
 */

export const SET_LOADING = '[ARTIST_AUDITIONS] SET_LOADING';
export const SET_ALL_JOB_LIST = '[ARTIST_AUDITIONS] SET_ALL_JOB_LIST';
export const APPEND_ALL_JOB_LIST = '[ARTIST_AUDITIONS] APPEND_ALL_JOB_LIST';
export const SET_ALL_JOB_LIST_META = '[ARTIST_AUDITIONS] SET_ALL_JOB_LIST_META';
export const SET_SHORTLISTED_JOB_LIST = '[ARTIST_AUDITIONS] SET_SHORTLISTED_JOB_LIST';
export const APPEND_SHORTLISTED_JOB_LIST = '[ARTIST_AUDITIONS] APPEND_SHORTLISTED_JOB_LIST';
export const SET_SHORTLISTED_JOB_LIST_META = '[ARTIST_AUDITIONS] SET_SHORTLISTED_JOB_LIST_META';
export const SET_APPLIED_JOB_LIST = '[ARTIST_AUDITIONS] SET_APPLIED_JOB_LIST';
export const APPEND_APPLIED_JOB_LIST = '[ARTIST_AUDITIONS] APPEND_APPLIED_JOB_LIST';
export const SET_APPLIED_JOB_LIST_META = '[ARTIST_AUDITIONS] SET_APPLIED_JOB_LIST_META';

export const SET_JOB_FILTER = '[ARTIST_AUDITIONS] SET_JOB_FILTER';
export const SET_SORT_TYPE = '[ARTIST_AUDITIONS] SET_SORT_TYPE';

export const SET_CURRENT_JOB = '[ARTIST_AUDITIONS] SET_CURRENT_JOB';
export const SET_CURRENT_JOB_META = '[ARTIST_AUDITIONS] SET_CURRENT_JOB_META';
